import React from 'react';
import DynamicHomePage from '../components/common/DynamicHomePage';

export default function HomePage() {
  return (
    <DynamicHomePage />
  );
}